var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M158.8,445.9c-7.5-2.1-14.3-5.3-17.9-12.5c-2.1-4.2-3.6-9-4.1-13.6c-4.2-44.9-8-89.8-11.9-134.8 c-3.6-40.9-7.1-81.7-10.7-122.6c-0.1-2.1-0.5-4.2-0.7-6.5c-7.5,0-14.8,0.1-22-0.1c-10.6-0.3-17.7-10.5-14.1-20.3 c2.2-6,6.5-9.5,12.9-10.2c1.7-0.1,3.5-0.2,5.2-0.2c24.5,0,49,0,73.4,0c1.5,0,3,0,4.8,0c0.1-1.7,0.2-3.1,0.2-4.5 c0.1-10.4-0.4-20.8,0.5-31.1c1.1-14.2,11.8-23.3,26.3-23.4c20.5-0.1,41,0,61.6,0c16.1,0,32.1,0,48.2,0c17,0,27.7,10.8,27.8,27.8 c0.1,10.2,0,20.5,0,31.2c1.8,0,3.2,0,4.6,0c25.2,0,50.4,0,75.7,0c8.2,0,13.8,3.6,16.2,9.9c3.7,9.9-3.3,20.4-14,20.7 c-7.2,0.2-14.3,0.1-21.5,0.2c-0.1,0-0.2,0.1-0.7,0.4c-0.7,7.8-1.5,15.9-2.2,24c-2.4,27.3-4.8,54.7-7.2,82 c-2.3,26.7-4.7,53.4-7,80.1c-2.3,26.1-4.5,52.2-6.9,78.2c-1.3,13.6-9,21.7-22,25.1C288.4,445.9,223.6,445.9,158.8,445.9z  M144.7,156.1c0.1,2.1,0.1,3.9,0.4,5.6c1.9,21.1,3.8,42.4,5.6,63.5c2.6,29.5,5.1,59.1,7.7,88.6c2.9,32.6,5.8,65.2,8.6,97.8 c0.2,2.7,0.9,3.6,3.7,3.6c57-0.1,114-0.1,171,0c2.4,0,3.4-0.7,3.6-3.3c0.7-9.5,1.6-19,2.4-28.4c2.4-27.2,4.8-54.4,7.2-81.6 c2.1-23.5,4.1-47,6.2-70.5c2.1-23.9,4.2-47.8,6.4-71.6c0.1-1.2,0-2.4,0-3.6C292.9,156.1,219,156.1,144.7,156.1z M205,124.9 c34.3,0,68.2,0,102.1,0c0-9.3,0-18.5,0-27.7c-34.1,0-68,0-102.1,0C205,106.5,205,115.5,205,124.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.417297781e3746246a8e40ba51e17a47.svg";
export { ForwardRef as ReactComponent };